import { useState } from "react";
import { Mail } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export const NewsletterSignup = ({ variant = "banner" }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // {ok, message}
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const { data } = await api.post("/newsletter/subscribe", {
        email,
        source: window.location.pathname,
      });
      setStatus({ ok: true, message: data.message });
      setEmail("");
    } catch (err) {
      setStatus({ ok: false, message: formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong — please try again." });
    } finally {
      setLoading(false);
    }
  };

  const dark = variant === "footer";
  return (
    <div className={dark ? "mx-auto max-w-xl text-center" : ""} data-testid={`newsletter-${variant}`}>
      {dark ? (
        <>
          <h3 className="font-display text-lg font-extrabold tracking-tight text-white">Weekly VPN Deal Alerts</h3>
          <p className="mt-1.5 text-sm text-slate-400">
            The best verified VPN discounts, once a week. No spam, unsubscribe anytime.
          </p>
        </>
      ) : (
        <>
          <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-[#7EAAFF]">
            <Mail size={14} /> Never miss a deal
          </p>
          <h2 className="mt-3 text-center font-display text-3xl font-black tracking-tighter text-white sm:text-4xl">
            Get Weekly Deal Alerts
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-center text-sm leading-relaxed text-slate-300">
            We check every VPN discount monthly — subscribe and we'll send the best verified deals straight to your
            inbox, once a week.
          </p>
        </>
      )}
      <form onSubmit={submit} className={`mx-auto mt-5 flex w-full max-w-md gap-2 ${dark ? "" : "sm:max-w-lg"}`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid={`newsletter-email-${variant}`}
          className="min-w-0 flex-1 border border-white/20 bg-white/[0.06] px-4 py-3 text-sm text-white placeholder:text-slate-500 backdrop-blur focus:border-[#4687FF] focus:outline-none"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid={`newsletter-submit-${variant}`}
          className="shrink-0 bg-[#4687FF] px-6 py-3 font-display text-sm font-bold text-white transition-colors duration-200 hover:bg-[#2563eb] disabled:opacity-60"
        >
          {loading ? "…" : "Subscribe"}
        </button>
      </form>
      {status && (
        <p
          data-testid={`newsletter-status-${variant}`}
          className={`mt-3 text-center text-sm font-semibold ${status.ok ? "text-emerald-400" : "text-rose-400"}`}
        >
          {status.message}
        </p>
      )}
    </div>
  );
};
